import {validateValue} from '../helpers/validation'

// Begin action types
export const VALIDATE_TALENT_EXPORT_FIELD = 'VALIDATE_TALENT_EXPORT_FIELD'
export const SET_TALENT_EXPORT_DROPDOWN_OPTIONS = 'SET_TALENT_EXPORT_DROPDOWN_OPTIONS'
export const CLEAR_TALENT_EXPORT_FIELDS = 'CLEAR_TALENT_EXPORT_FIELDS'
// End action types

export const setTalentExportDropdownOptions = (countryNames, statuses) => ({
  type: SET_TALENT_EXPORT_DROPDOWN_OPTIONS,
  countryNames,
  statuses
});

export const clearTalentExportFields = () => ({
  type: CLEAR_TALENT_EXPORT_FIELDS
});

export const validateTalentExportField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_TALENT_EXPORT_FIELD,
    field
  }
}
